var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',[_c('a-button',{attrs:{"disabled":_vm.isDisabled,"type":"primary"},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.config.label)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }